import { site, socials } from '@/content/site'
import styles from './Footer.module.css'

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p className={styles.note}>
          © {new Date().getFullYear()} {site.name}
        </p>
        <ul className={styles.links}>
          {socials.map((social) => (
            <li key={social.href}>
              <a
                href={social.href}
                target={social.href.startsWith('mailto:') ? undefined : '_blank'}
                rel="noopener noreferrer"
              >
                {social.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  )
}
